import React from 'react';
import Wine from '../components/Wine';

const WinePage = () => {
  return (
    <div className="page-container">
      <Wine />
    </div>
  );
};

export default WinePage;